
import HeroSectionInfo from '@/components/hero-section-info';
import WhyBodeStoreName from '@/store/why-bode/name';
import { WhyBodeTrackEvent } from '@/constants/AnalyticEvents';

export default {
  name: 'WhyBodeHeroSection',
  components: {
    HeroSectionInfo,
  },
  computed: {
    heroContent() {
      return this.$store.state[WhyBodeStoreName].heroContent;
    },
    trackEvent() {
      return WhyBodeTrackEvent.HeroClick;
    },
  },
};
